import axios from 'axios';
import { fixDate } from '../helpers/date-helpers';

export const apiAffiliateLogin = async (email, code) => {
    const result = await axios({
        method: 'post',
        url: '/api/v1/Affiliate/Login',
        data: { email, code },
    });
    return result.data;
};

export const apiAffiliateLogout = async () => {
    await axios({
        method: 'post',
        url: '/api/v1/Affiliate/Logout',
    });

    window.location = '/';
};

export const apiAffiliateCodeCheck = async (affiliateCode) => {
    const result = await axios({
        method: 'get',
        url: '/api/v1/Affiliate/Code',
        params: { affiliateCode },
    });
    return result.data;
};

export const apiAffiliateReport = async (tourFrom) => {
    const result = await axios({
        method: 'get',
        url: '/api/v1/Report/Affiliate',
        params: { tourFrom: fixDate(tourFrom) },
    });
    return result.data;
};
